/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-27 10:13:42
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Banner, TextStyle, List } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { getShop } from 'src/helpers';

type Props = {
  permissionURL: string,
  valueRedirect?: string,
  recommendationType?: string
};

type ComposedProps = Props & WithI18nProps;

class GrantPermissionNotif extends Component<ComposedProps> {
  render() {
    const { i18n, recommendationType } = this.props;

    const itemNotifySubject =
      recommendationType === 'trending-products'
        ? 'Trending'
        : recommendationType === 'related-items'
        ? 'Related'
        : recommendationType === 'recently-purchased'
        ? 'RecentlyPurchased'
        : 'FBT';

    return (
      <div className="BC-Container__Notifications__GrantPermissionBanner">
        {!recommendationType ? (
          <Banner
            title={i18n.translate('AdminHTML.Recommendation.GrantPermissionNotif.bannerTitle')}
            status="warning"
            action={{
              onAction: this.handleUpdatePermission,
              content: i18n.translate('AdminHTML.Recommendation.GrantPermissionNotif.action')
            }}>
            <List type="bullet">
              <List.Item>
                {i18n.translate('AdminHTML.Recommendation.GrantPermissionNotif.content1', {
                  t1: (
                    <TextStyle variation="strong">
                      {i18n.translate('AdminHTML.Recommendation.GrantPermissionNotif.content1_t1')}
                    </TextStyle>
                  ),
                  t2: (
                    <TextStyle variation="strong">
                      {i18n.translate('AdminHTML.Recommendation.GrantPermissionNotif.content1_t2')}
                    </TextStyle>
                  )
                })}
              </List.Item>
              <List.Item>
                {i18n.translate('AdminHTML.Recommendation.GrantPermissionNotif.content2', {
                  t1: (
                    <TextStyle variation="strong">
                      {i18n.translate('AdminHTML.Recommendation.GrantPermissionNotif.content2_t1')}
                    </TextStyle>
                  ),
                  t2: (
                    <TextStyle variation="strong">
                      {i18n.translate('AdminHTML.Recommendation.GrantPermissionNotif.content2_t2')}
                    </TextStyle>
                  )
                })}
              </List.Item>
            </List>
          </Banner>
        ) : (
          <Banner
            status="warning"
            action={{
              onAction: this.handleUpdatePermission,
              content: i18n.translate('AdminHTML.Recommendation.GrantPermissionNotif.action')
            }}>
            {i18n.translate('AdminHTML.Recommendation.GrantPermissionNotif.itemContent', {
              t1: (
                <>
                  {i18n.translate(
                    `AdminHTML.Recommendation.GrantPermissionNotif.itemContent_${itemNotifySubject}`
                  )}
                </>
              )
            })}
          </Banner>
        )}
      </div>
    );
  }

  handleUpdatePermission = () => {
    const { permissionURL, valueRedirect } = this.props;

    // Setup redirect URI
    try {
      localStorage.setItem(`${getShop()}-permissionApproval-redirectURI`, valueRedirect);
    } catch (error) {}
    window.top.location.href = permissionURL;
  };
}

GrantPermissionNotif.defaultProps = {
  valueRedirect: '/recommendation-widgets'
};

export default withI18n()(GrantPermissionNotif);
